module.exports = __webpack_public_path__ + "static/images/containers/ClanLanding/images/main_card_background_big_cn.25c417bc.jpg";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanLanding/images/main_card_background_big_cn.jpg
// module id = 3013
// module chunks = 11